import { Box } from "@mui/material";
import React, { useState } from "react";

import { Dropzone } from "components/common/Dropzone/Dropzone";
import { Modal } from "new-components/modals/Modal";

interface AddImageQueryModalProps {
  open: boolean;
  onClose: () => void;
  addImage: (images: File[]) => void;
  loading: boolean;
  setLoading: (loading: boolean) => void;
  success: boolean;
  error: string | null;
  setError: (error: string | null) => void;
  uploadMessage?: string | null;
  failedFiles?: File[];
}

export function AddImageQueryModal({
  open,
  onClose,
  addImage,
  loading,
  setLoading,
  success,
  error,
  setError,
  uploadMessage,
  failedFiles = [],
}: AddImageQueryModalProps) {
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const handleClose = () => {
    if (!loading) {
      onClose();
      setError(null);
      setErrorMessage(null);
    }
  };

  return (
    <Modal
      size="medium"
      open={open}
      onClose={handleClose} // Ensure the modal doesn't close when loading is true
      title="Add Image(s)"
      onCancel={handleClose}
      isCancelDisabled={loading}
      body={[
        <Box p={4} width="100%" height="100%">
          <Dropzone
            onDrop={(files) => {
              addImage(files);
              setLoading(true);
            }}
            maxFiles={15}
            loading={loading}
            uploadMessage={uploadMessage}
            errorMessage={errorMessage}
            setErrorMessage={setErrorMessage}
            showSuccess={success}
            successMessage="Image(s) uploaded successfully!"
            error={error}
            setError={setError}
            failedFiles={failedFiles}
          />
        </Box>,
      ]}
    />
  );
}
